<div class="overflow-y-auto overflow-x-hidden">
	<app-header-views
		[title]="translateRoles.title"
		[textButton]="translateRoles.buttonNew"
		(actionButton)="openDialogRole()"
	></app-header-views>
	<app-modal-alert
		*ngIf="openAlert"
		[value]="valueModalDelete"
		[nameModal]="textModal"
		[elementsDelete]="elementsDeleteModal"
		(closeModalAlert)="closeModalAlert($event)"
	></app-modal-alert>
	<div class="flex flex-row">
		<div class="w-full">
			<layout-table
				(action)="buttonAction($event)"
				(isLoading)="refreshData($event)"
				[filterList]="filterList"
				[optionsFilter]="columnsFilter"
				[heigth]="154"
				[widthFilter]="414"
				(filterSelected)="filterSelected($event)"
				(filterValues)="getFilterValues($event)"
			>
				<app-pagination
					slot="end"
					class="hidden md:block"
					[info]="pagination"
					(emitNavigationPag)="emitNavigation($event)"
				>
				</app-pagination>
				<ngx-datatable
					*ngIf="!isLoading"
					table
					[columns]="columns"
					[rows]="rowsFilters || []"
					class="mg-table fullscreen"
					[columnMode]="modeColum"
					[headerHeight]="50"
					[footerHeight]="0"
					[rowHeight]="50"
					[limit]="10"
					[scrollbarH]="true"
					[scrollbarV]="true"
					[messages]="{ emptyMessage: '' }"
					[selected]="selected"
					[rowClass]="getRowClass"
					[selectionType]="selectionType.checkbox"
					(select)="onSelect($event)"
					[sorts]="[{ prop: 'name', dir: 'asc' }]"
				>
					<ngx-datatable-column
						[width]="50"
						[sortable]="false"
						[canAutoResize]="false"
						[draggable]="false"
						[resizeable]="false"
					>
						<ng-template
							ngx-datatable-header-template
							let-value="value"
							let-allRowsSelected="allRowsSelected"
							let-selectFn="selectFn"
						>
							<div class="mng-checkbox">
								<input
									type="checkbox"
									[checked]="allRowsSelected"
									(change)="selectFn(!allRowsSelected)"
								/>
								<span class="checkbox"></span>
							</div>
						</ng-template>
						<ng-template
							ngx-datatable-cell-template
							let-value="value"
							let-isSelected="isSelected"
							let-onCheckboxChangeFn="onCheckboxChangeFn"
						>
							<div class="mng-checkbox">
								<input
									type="checkbox"
									[checked]="isSelected"
									(change)="onCheckboxChangeFn($event)"
								/>
								<span class="checkbox"></span>
							</div>
						</ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column
						[headerClass]="'text-complementary-color-a font-bold'"
						[name]="columnsElement.name"
						*ngFor="let columnsElement of columns"
						[cellClass]="getCellClass"
					>
						<ng-template
							ngx-datatable-header-template
							let-value="value"
							let-allRowsSelected="allRowsSelected"
							let-selectFn="selectFn"
						>
							<span> {{ columnsElement?.label || '' }} </span>
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						name="Actions"
						[headerClass]="'text-complementary-color-a font-bold'"
					>
						<ng-template
							ngx-datatable-header-template
							let-value="value"
							let-allRowsSelected="allRowsSelected"
							let-selectFn="selectFn"
						>
							<span> {{ translateRoles.table!.action || '' }} </span>
						</ng-template>
						<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
							<div class="w-full flex justify-center">
								<app-actions-table
									[optionsTable]="optionsTable"
									[value]="row"
									(action)="actions($event)"
								></app-actions-table>
							</div>
						</ng-template>
					</ngx-datatable-column>
				</ngx-datatable>
				<app-loading-spinner loading *ngIf="isLoading"></app-loading-spinner>
			</layout-table>
		</div>
	</div>
</div>
